import { type ReactNode, useState, useEffect } from 'react';
import { useScrollReveal, useRevealStyle } from '@/hooks/useScrollReveal';

interface FadeInSectionProps {
  children: ReactNode;
  className?: string;
  threshold?: number;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
  distance?: number;
  duration?: number;
  as?: 'section' | 'div' | 'article' | 'aside';
  id?: string;
}

export default function FadeInSection({
  children,
  className = '',
  threshold = 0.12,
  delay = 0,
  direction = 'up',
  distance = 20,
  duration = 700,
  as: Tag = 'div',
  id,
}: FadeInSectionProps) {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(threshold);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(timer);
  }, []);

  const animatedStyle = useRevealStyle(isVisible, { delay, direction, distance, duration });
  const style = ready ? animatedStyle : {};

  return (
    <Tag
      ref={ref as React.RefObject<HTMLElement | null>}
      id={id}
      className={className}
      style={style}
    >
      {children}
    </Tag>
  );
}